import React, { useState } from 'react';
import Select from './Select';
import '../styles/Filters.css';

const FilterExternalDropdown = ({ 
    options = [], 
    isMulti = false, 
    filterName, 
    searchFilters, 
    setSearchFilters, 
    closeFilter,
    columnName = 'Filter',
    alignRight = false,
    setWrapperRef,
}) => {
    // 1. Get initial value from searchFilters
    const initialValues = searchFilters?.[filterName]?.value || (isMulti ? [] : '');
    const [inputValue, setInputValue] = useState(initialValues);

    // 2. Keep selected options matched internally
    // (We trust options array directly since you always pass value and label)
    const selectedValues = Array.isArray(inputValue) ? inputValue : (inputValue ? [inputValue] : []);
    const selectedOptions = options.filter(opt => selectedValues.includes(opt.value));

    // 3. Clean Apply logic
    const handleApply = () => {
        // If they cleared the selection
        if ((isMulti && inputValue.length === 0) || (!isMulti && !inputValue)) {
            setSearchFilters(prev => {
                const updated = { ...prev };
                delete updated[filterName];
                return updated;
            });
            closeFilter();
            return;
        }

        // Apply new mapping
        setSearchFilters(prev => ({
            ...prev,
            [filterName]: {
                filter_type: isMulti ? 'one_of' : 'equals',
                value: inputValue
            }
        }));
        closeFilter();
    };

    return (
        <div
            className={`filter_wrapper${alignRight ? ' filter_wrapper_align_right' : ''}`}
            ref={setWrapperRef}
        >
            <Select
                label={`Select ${columnName}`}
                placeholder="Search..."
                options={options}
                value={selectedOptions}
                onChange={vals => {
                    if (isMulti) {
                        setInputValue(vals ? vals.map(v => v.value) : []);
                    } else {
                        setInputValue(vals ? vals.value : '');
                    }
                }}
                isMulti={isMulti}
                isSearch={true}
            />
            <div className='filter_buttons mt-3'>
                <button type="button" onClick={closeFilter} className="btn-cancel">Cancel</button>
                <button type="button" onClick={handleApply} className="btn-apply">Apply</button>
            </div>
        </div>
    );
};

export default FilterExternalDropdown;
